import Sun from '../../src/legacy/Sun.tsx';
export default Sun;
